import { render, staticRenderFns } from "./widthPre.vue?vue&type=template&id=675a128a&scoped=true&"
import script from "./widthPre.vue?vue&type=script&lang=js&"
export * from "./widthPre.vue?vue&type=script&lang=js&"
import style0 from "./widthPre.vue?vue&type=style&index=0&id=675a128a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675a128a",
  null
  
)

export default component.exports